/*
 * Copyright (c) 2018
 *    Internal Valuation, LLC - https://www.internalvaluation.com
 *    Author: Xaero Zero - xaerozero@icloud.com
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import {Injectable} from '@angular/core';
import {HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpResponse} from '@angular/common/http';
import {Observable} from 'rxjs';
import {tap} from 'rxjs/operators';
import {AppVersion} from '../model';
import { LogService } from 'src/app/services';


declare var require: any;

@Injectable()
export class HttpInterceptorService implements HttpInterceptor {

  constructor(private logService : LogService) {}

  private static beHeaderName = 'crm-be-app-version';
  private appVersion: string = require('../../../package.json').version;

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    request = request.clone({
      setHeaders: {
        Authorization: `Bearer ${localStorage.getItem('R-CRM-TOKEN')}`,
        'x-app-version': this.appVersion,
        'x-app-name': 'R-CRM-FE'
      }
    });

    return next.handle(request)
      .pipe(
        tap(response => {
          if (response instanceof HttpResponse) {
            const serverVersion = response.headers.get('x-app-version');
            if (serverVersion) {
              if (this.isClientOutdated(serverVersion)) {
                // Show Outdated UI only once
                this.logService.warn('Client Application Outdated!');
              }
            }
          }
        }, error => {
          this.logService.error(error.status);
          this.logService.error(error.message);
        })
      );
  }
  private isClientOutdated(serverVersion: string): boolean {
    const userVersion = localStorage.getItem(HttpInterceptorService.beHeaderName);
    if (!userVersion) {
      localStorage.setItem(HttpInterceptorService.beHeaderName, serverVersion);
      return false;
    } else {
      const sv = AppVersion.parseVersion(serverVersion);
      const uv = AppVersion.parseVersion(userVersion);

      if (sv && uv)
        if (sv.major > uv.major || sv.minor > uv.minor || sv.patch > uv.patch) {
          localStorage.setItem(HttpInterceptorService.beHeaderName, serverVersion);
          return true;
        } else if (sv.build_number || uv.build_number) {
          if (sv.build_number !== uv.build_number) {
            localStorage.setItem(HttpInterceptorService.beHeaderName, serverVersion);
            return true;
          }
        }
    }
    return false;
  }
}
